var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2048(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlns: "http://www.w3.org/2000/svg",
    height: 300,
    viewBox: "0 0 300 300",
    width: 300,
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.93,
    ry: 46.812,
    height: 300,
    width: 300,
    y: -2.8422e-14,
    x: 0,
    fill: "#edc53f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.94118,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.494 180.2h-43.625v-9.9295c7.8238-7.8223 30.474-25.409 28.15-35.53-3.0721-9.6888-16.516-3.1041-18.497 1.3179l-9.606-7.34c9.9051-15.277 40.548-13.517 41.418 6.1608 0.13417 15.553-15.328 25.09-24.344 33.668v0.59536h26.504z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.69 150.12c0.0631 17.934-5.1146 31.485-23.027 31.6-19.083-0.0356-23.56-13.743-23.495-31.488-0.0649-17.78 4.7813-31.58 23.495-31.614 18.066 0.0335 22.964 13.854 23.027 31.502zm-33.734 0.11236c0.11555 7.0266 0.67599 20.614 10.483 20.711 9.7053 0.11164 10.513-14.386 10.538-20.823-0.12683-6.991-0.48779-20.502-10.426-20.57-10.098-0.18412-10.528 13.963-10.595 20.682z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.71 118.61c8.5245 0.0453 20.45 3.7255 20.459 14.803-0.009 8.758-3.6498 10.729-10.64 14.548 7.695 4.6453 12.534 8.1112 12.623 17.241-0.0892 11.956-11.652 16.271-22.443 16.351-11.363-0.0799-22.57-4.1346-22.744-16.523 0.17894-8.9376 5.4196-14.001 11.103-16.861-6.4909-3.9806-9.5333-6.0364-9.3731-14.84-0.1602-10.907 11.817-14.673 21.014-14.719zm-10.534 45.347c-0.0432 5.6839 4.6963 7.7436 10.41 7.6954 5.5049 0.0482 9.6719-2.2453 9.7399-7.1674 0.0479-8.2667-9.7344-11.879-9.7344-11.879s-10.459 3.6126-10.416 11.351zm10.441-34.982c-4.7979-0.0409-9.1512 1.0398-9.1739 5.677 0.0227 5.3995 9.0774 9.104 9.0774 9.104s8.3311-3.6544 8.4594-9.4847c-0.1918-4.2526-3.8086-5.3372-8.3629-5.2963z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.22 170.07h-7.77v10.088h-11.51v-10.08h-30.06v-11.137l29.332-38.853h12.238v39.776h7.77zm-19.28-33.723-18.038 23.517h18.038z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2048);
export default __webpack_public_path__ + "static/media/2048.6fb645c66fb808034ce6f0544ae975ef.svg";
export { ForwardRef as ReactComponent };